import _isEmpty from 'lodash/isEmpty';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import I18n from 'i18n-js';
import { Popover } from 'grab-ui';
import DivButton from 'components/v2/div-button/div-button';

import { getReceiptRecipients } from 'helper/history-order';

import css from './receipt-download.less';

const cx = classnames.bind(css);

class ReceiptDownload extends Component {
  onClickOpenReceipt = receiptLink => () => {
    window.open(receiptLink);
  };

  renderDownloadButton = (receiptLink, disable) => {
    const { simpleDownloadBtn } = this.props;
    return (
      <DivButton
        onClick={!disable ? this.onClickOpenReceipt(receiptLink) : () => {}}
        className={cx({
          downloadBtn: !simpleDownloadBtn,
          'downloadBtn-disable': disable,
        })}
      >
        {I18n.t('v2.orderTable.action.downloadReceipt')}
      </DivButton>
    );
  };

  renderRecipientWithReceipt = recipient => {
    const { contact, location } = recipient;

    return (
      <DivButton
        className={css.recipient}
        onClick={this.onClickOpenReceipt(recipient.orderReceiptLink)}
      >
        <div>
          <h5>{contact.name}</h5>
          <h6>{contact.phone}</h6>
          <h6>{location.address}</h6>
        </div>
        <img src={require('public/icons/download.svg')} alt="" />
      </DivButton>
    );
  };

  renderReceiptPopup = recipients => {
    const { simpleDownloadBtn } = this.props;
    const content = recipients.map(recipient =>
      this.renderRecipientWithReceipt(recipient),
    );

    return (
      <Popover content={content} overlayClassName={css.popover} trigger="click">
        <DivButton className={cx({ downloadBtn: !simpleDownloadBtn })}>
          {I18n.t('v2.orderTable.action.downloadReceipt')}
        </DivButton>
      </Popover>
    );
  };

  render() {
    const { order } = this.props;
    const recipients = getReceiptRecipients(order);
    if (_isEmpty(recipients)) {
      return this.renderDownloadButton(null, true);
    }

    return recipients.length === 1
      ? this.renderDownloadButton(recipients[0].orderReceiptLink, false)
      : this.renderReceiptPopup(recipients);
  }
}

ReceiptDownload.propTypes = {
  simpleDownloadBtn: PropTypes.bool,
  order: PropTypes.shape({}).isRequired,
};

ReceiptDownload.defaultProps = {
  simpleDownloadBtn: false,
};

export default ReceiptDownload;
